// const url_api = "http://localhost:3001/";
const url_api = "https://api-cerveau.onrender.com/";

export default url_api;


